import HealthServiceModuleDashboard from "@/components/HealthServiceModuleDashboard";

/* Compatibilidade textual com a regressão dos módulos adicionais do portal:
Módulo navegável · fase 2
*/

export default function ApsDigitalPage() {
  return (
    <HealthServiceModuleDashboard
      title="APS Digital"
      eyebrow="Cuidado longitudinal digital e acompanhamento de adesão"
      badgeLabel="Dashboard de homologação ativo"
      serviceKey="aps_digital"
      accentColor="#059669"
      gradientClassName="bg-[radial-gradient(circle_at_top_right,_rgba(16,185,129,0.22),_transparent_38%),linear-gradient(135deg,#f6fffb_0%,#ebfff7_42%,#ffffff_100%)]"
      description="A APS Digital passa a mostrar, em uma tela única, o comportamento da adesão, a penetração na base elegível, a recorrência do uso e a experiência percebida em uma jornada pensada para acompanhamento contínuo."
      focusTitle="O que observar neste módulo"
      focusItems={[
        {
          title: "Adesão e penetração da base",
          description: "Os cards ajudam a entender quantas vidas elegíveis realmente estão entrando na jornada e qual o alcance do cuidado digital no período.",
        },
        {
          title: "Recorrência e cadência de uso",
          description: "A série temporal mostra se o módulo está sustentando uso frequente e saudável ou se a jornada está perdendo continuidade ao longo dos dias.",
        },
        {
          title: "Experiência e sinais de risco",
          description: "A visão conjunta de percepção do usuário e risco populacional ajuda a priorizar melhorias operacionais e clínicas com mais rapidez.",
        },
      ]}
    />
  );
}
